import decode from 'jwt-decode'
/**
 * @param data - token
 */
export default {
  decode (token) {
    return decode(token)
  }
}
